// extracted by mini-css-extract-plugin
module.exports = {"titleCard":"style_titleCard__1fQ7k","img":"style_img__EM7Ld","title":"style_title__1ADQg"};